module.exports = __webpack_public_path__ + "static/img/bye_bye.a168b258.png";